import {Injectable} from "@angular/core";
import {CommonService} from "./common.service";

@Injectable({
  providedIn: 'root'
})
export class MessageUtilsService {
  constructor(private commonService: CommonService) {
  
  }
  
  handleMessage(message) {
    message.userAvatar = this.commonService.setAvatarUrl(message.userAvatar);
    message.createTime = this.commonService.getLocalDateTimeStr(message.createTime);
    
    if (message.type === 'order') {
      message.catalog = 'demand';
      message.connectorCss = 'demand-connector';
      return this.handleOrderMessage(message);
    }
    
    if (message.type === 'reply_order') {
      message.catalog = 'supply';
      message.connectorCss = 'supply-connector';
      return this.handleReplyOrderMessage(message);
    }
    
    if (message.type === 'system') {
      message.title = '系统消息';
      message.catalog = 'system';
      message.connectorCss = 'system-connector';
      return message;
    }
  }
  
  handleOrderMessage(message){
    let json = JSON.parse(message.contentJson);
    message.orderJson = json;
    let orderNumber = json.orderNumber;
    
    let userNickName = message.userName;
    if (message.userNickName) {
      userNickName = message.userNickName;
    }
    
    message.user = userNickName;
    message.title = "采购方订单";
    message.content = `您的客户[${userNickName}]发起了订单需求，订单号[${orderNumber}]，请尽快处理。`;
    message.type2 = "order"
    
    return message;
  }
  
  handleReplyOrderMessage(message){
    let json = JSON.parse(message.contentJson);
    message.orderJson = json;
    let orderNumber = json.orderNumber;
    
    let userNickName = message.userName;
    if (message.userNickName) {
      userNickName = message.userNickName;
    }
    
    message.user = userNickName;
    message.title = "采购方订单";
    message.content = `您的供应商[${userNickName}]回复了需求，订单号[${orderNumber}]，请核对。`;
    message.type2 = "order"
    
    return message;
  }
}
